import { render, staticRenderFns } from "./Clinical.vue?vue&type=template&id=8d51d6da"
import script from "./Clinical.vue?vue&type=script&lang=js"
export * from "./Clinical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports